import React from "react";

import Typography from "veneer/Typography";

interface WsExceptionStatusProps {
  exception?: string | number;
}

function WsExceptionStatus({ exception }: WsExceptionStatusProps) {
  if (
    !exception ||
    (typeof exception !== "string" && typeof exception !== "number")
  ) {
    return null;
  }

  return (
    <Typography component="span" variant="body2">
      ({exception})
    </Typography>
  );
}

export { WsExceptionStatus };
export default WsExceptionStatus;
